import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=user
  const [token, setToken] = useState(() => localStorage.getItem("ainalem_token") || "");

  useEffect(() => {
    (async () => {
      try {
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const { data } = await api.get("/auth/me", { headers });
        setUser(data);
      } catch {
        setUser(false);
      }
    })();
  }, []); // eslint-disable-line

  const persistToken = (tk) => {
    setToken(tk);
    if (tk) localStorage.setItem("ainalem_token", tk);
    else localStorage.removeItem("ainalem_token");
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persistToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    persistToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    persistToken("");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
